import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";

export function getSolvedProblemsTransport(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "Potřebujeme jeden systém na řízení celé firmy",
			desc: `Přepravní firmy často trápí, že používají příliš mnoho nepropojených nástrojů. Pomáháme jim všechny [${getIntegrationsPath(tenant)}][[sjednotit pod jednu střechu]], od zpracování zásilek až po reporting.`,
			bg: "bg-fstgrey-400",
		},
		{
			title: "Chceme mít účetnictví plně pod kontrolou",
			desc: "Zajišťujeme kompletní digitální správu účetní agendy, která je přehledná, automatizovaná a snadno dostupná kdykoli a odkudkoli.",
			bg: "bg-fstgrey-500",
		},
		{
			title: "Potřebujeme odbavit větší objem zásilek",
			desc: "Logistickým i spedičním firmám pomáháme zefektivnit zpracování zásilek, mimo jiné digitalizací a automatizací rutinních procesů. ",
			bg: "bg-fstgrey-600",
		},
		{
			title: "Chceme lépe plánovat práci řidičů",
			desc: "Vyvíjíme nástroje pro chytré plánování nakládek a vykládek s ohledem na aktuální dostupnost řidičů i vozidel v terénu.",
			bg: "bg-fstgrey-700",
		},
		{
			title: "Máme chaos v pojištění vozidel",
			desc: "Zajišťujeme snadnou správu pojistných smluv i propojení s dalšími agendami, které se týkají firemních aut.",
			bg: "bg-fstgrey-800",
		},
		{
			title: "Topíme se v papírových „camrácích“",
			desc: `Pomůžeme vám [${getDigitalizationAndAutomationPath(tenant)}][[digitalizovat]] účtenky i ručně psané záznamy o zásilkách. Není potřeba se přehrabovat v papírech, vše najdete na jednom místě v digitální podobě.`,
			bg: "bg-fstgrey-900",
		},
		{
			title: "Ztrácíme přehled o výkonnosti firmy a lidí",
			desc: "Díky statickým i prediktivním modelům vám umožníme rozhodovat se na základě dat, ne pocitů. Ať už jde o efektivitu práce, nebo plánování kapacit.",
			bg: "bg-fstgrey-800",
		},
		{
			title: "Hledáme řešení pro chytré úschovny a sdílené boxy",
			desc: "Vyvíjíme systémy pro úschovny ve veřejných i komerčních prostorách, například na nádražích nebo v blízkosti firem. Bezpečné, automatizované a snadno integrovatelné.",
			bg: "bg-fstgrey-800",
		},
	];
}
